import { useSelector } from 'react-redux'
import { selectTimeZone } from '../../../app/slice'

export const UseTimeZone = () => {
  const timeZone = useSelector(selectTimeZone)

  return timeZone
}
